// extracted by mini-css-extract-plugin
module.exports = {"main":"Socials_main___iTsF","item":"Socials_item__CElhu","icon":"Socials_icon__SS3zT"};